import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';

import API from 'services/api';
import ICongregation from 'types/ICongregation';
import { useCongregationId } from './useCongregationId';

export const useCongregation = () => {
    const id = useCongregationId();

    const loadData = async () => {
        const query = gql`
            query {
                congregacion(id: "${id}"){
                    id
                    nombre
                    pais
                }
            }
        `;
        const response = await API.graphql(query);
        return response.congregacion;
    };

    return useQuery<ICongregation, Error>({
        queryKey: ['congregation', id],
        queryFn: loadData,
    });
};
